import { createSlice } from "@reduxjs/toolkit";
import { getUserList } from "../utilsReduxApi/getUserList";
import { getDealList } from "../utilsReduxApi/getDealList";
import { getVendorList } from "../utilsReduxApi/getVendorList";
import { getClientList } from "../utilsReduxApi/getClientList";
import { getCompanyList } from "../utilsReduxApi/getCompanyList";
import { getLocationList } from "../utilsReduxApi/getLocationList";
import { getSiteList } from "../utilsReduxApi/getSiteList";
import { getWalkthroughList } from "../utilsReduxApi/getWalkthrough";
import { getInspectionList } from "../utilsReduxApi/getInspectionList";
import { getInventoryLookup } from "../utilsReduxApi/getInventoryLookup";
import { getQuoteList } from "../utilsReduxApi/getQuoteList";
// import { getQuoteList } from '../utilsReduxApi/getQuoteList';
import { getRoleLookup } from "../utilsReduxApi/getRole";
// import {getDealList} from '../utilsReduxApi/getDealList';
import { getDepartmentList } from "../utilsReduxApi/getDepartmentList";
import { getBrandListLookup, getSolarListLookup } from "../utilsReduxApi/getBrandSolarlist";
import { getInverterLookup } from "../utilsReduxApi/InverterLookup";
import { getPriceList } from "../utilsReduxApi/getPriceList";
import { getInventorySolarPanelLookUp } from "../utilsReduxApi/getInventorySolarPanelLookUp";
import { getInventorySolarPanel } from "../reduxApi/InventorySolarPanelReduxApi";
import { getRolesLookUp } from "../utilsReduxApi/getRolesLookUp";
const UtilsSlice = createSlice({
  name: "utils",
  initialState: {
    userList: [],
    vendorList: [],
    clientList: [],
    companyList: [],
    locationList: [],
    siteList: [],
    walkthroughList: [],
    inspectionList: [],
    quoteList: [],

    QuoteList: [],
    dealsList: [],
    roleList: [],
    departmentList: [],
    brandList: [],
    solarList: [],
    getInverterList: [],
    getPriceList: [],
    getInventorySolarPanelList: [],
    teleRoleList:[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVendorList.fulfilled, (state, action) => {
      // console.log("action.payload", action.payload);
      state.vendorList = action.payload.result;
      // console.log(state.vendorList);
    });
    builder
      .addCase(getVendorList.rejected, (state, action) => {
        console.error("Failed to fetch vendor list:", action.error);
      })

      .addCase(getUserList.fulfilled, (state, action) => {
        console.log("action.payload---", action.payload);
        state.userList = action?.payload?.result;
      })

      .addCase(getClientList.fulfilled, (state, action) => {
        // console.log("action.payload", action.payload);
        state.clientList = action?.payload?.data?.result;
      })
      .addCase(getRolesLookUp.fulfilled, (state, action) => {
        console.log("action.payload--->", action.payload);
        state.teleRoleList = action?.payload?.data?.records;
        console.log("state.teleRoleList",state.teleRoleList);
        
      })
      .addCase(getCompanyList.fulfilled, (state, action) => {
        // console.log("company-action", action.payload);
        state.companyList = action?.payload?.data?.records;
      })
      .addCase(getLocationList.fulfilled, (state, action) => {
        // console.log("location-action", action.payload);
        state.locationList = action?.payload?.data?.result;
      })
      .addCase(getSiteList.fulfilled, (state, action) => {
        // console.log("site-action", action.payload);
        state.siteList = action.payload.data.result;
      })
      .addCase(getWalkthroughList.fulfilled, (state, action) => {
        // console.log("walkthrough-action", action.payload);
        state.walkthroughList = action?.payload?.data?.result;
      })
      .addCase(getQuoteList.fulfilled, (state, action) => {
        // console.log("quote-action", action.payload);
        state.QuoteList = action?.payload?.data?.result;
      })
      .addCase(getInventoryLookup.fulfilled, (state, action) => {
        // console.log("quote-action", action.payload);
        state.quoteList = action.payload.data.invertResp;
      })
      .addCase(getDealList.fulfilled, (state, action) => {
        // console.log("<<<<< ==== deal-action ====>>>>",action.payload);
        state.dealsList = action?.payload.data?.resp;
      })
      .addCase(getRoleLookup.fulfilled, (state, action) => {
        // console.log("role-action", action.payload);
        state.roleList = action.payload.data.result;
        // console.log("role-action--->", state?.roleList);
      });
    builder.addCase(getDepartmentList.fulfilled, (state, action) => {
      state.departmentList = action.payload.data.response;
    });

    builder.addCase(getBrandListLookup.fulfilled, (state, action) => {
      state.brandList = action.payload.data.resp;
    });
    builder.addCase(getSolarListLookup.fulfilled, (state, action) => {
      state.solarList = action.payload.data.resp;
    });
    builder.addCase(getInverterLookup.fulfilled, (state, action) => {
      state.getInverterList = action.payload.data.resp;
    });
    builder.addCase(getPriceList.fulfilled, (state, action) => {
      state.getPriceList = action.payload.data.queryResponse;
      console.log("getPriceList", action.payload.data.queryResponse);
    });
     builder.addCase(getInventorySolarPanelLookUp.fulfilled, (state, action) => {
      state.getInventorySolarPanelList = action.payload.data.inventorySolarPanelResp;
      console.log("getInventorySolarPanelList", action.payload.data.inventorySolarPanelResp);
    });
  },
});

export default UtilsSlice.reducer;
